import moment from 'moment-timezone';

const zone = 'America/Bogota';
const weekdayNames = [
  ['domingo', 'sunday', 'sun'], ['lunes', 'monday', 'mon'],
  ['martes', 'tuesday', 'tue'], ['miercoles', 'wednesday', 'wed'],
  ['jueves', 'thursday', 'thu'], ['viernes', 'friday', 'fri'], ['sabado', 'saturday', 'sat'],
];
const normalize = value => String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const tokens = value => Array.isArray(value) ? value : String(value || '').split(/[,;\n]+/).map(item => item.trim()).filter(Boolean);

export function experienceSchedule(payload) {
  try {
    const data = typeof payload === 'string' ? JSON.parse(payload) : payload;
    return data && data.availability ? { ...data.availability } : null;
  } catch (error) { return null; }
}

export function scheduleDates(value) {
  return tokens(value).map(item => moment(String(item).trim(), ['YYYY-MM-DD', 'DD/MM/YYYY'], true))
    .filter(date => date.isValid()).map(date => date.format('YYYY-MM-DD'));
}

export function scheduleWeekdays(value) {
  return tokens(value).map(item => {
    const name = normalize(item);
    if (/^[0-6]$/.test(name)) return Number(name);
    return weekdayNames.findIndex(names => names.includes(name));
  }).filter(day => day >= 0);
}

export function isExperienceDateScheduled(value, payload, now = new Date()) {
  const schedule = experienceSchedule(payload);
  const day = moment.tz(String(value), 'YYYY-MM-DD', true, zone);
  if (!schedule || !day.isValid() || day.isBefore(moment.tz(now, zone).startOf('day'))) return false;
  const key = day.format('YYYY-MM-DD');
  if (scheduleDates(schedule.blockedDates).includes(key)) return false;
  if (schedule.calendar === 'specificDates') {
    if (!scheduleDates(schedule.dates).includes(key)) return false;
  } else if (schedule.calendar === 'specificDays') {
    if (!scheduleWeekdays(schedule.days).includes(day.day())) return false;
  } else if (schedule.calendar !== 'everyDay') return false;

  const time = /^([01]\d|2[0-3]):[0-5]\d$/.test(schedule.startTime || '') ? schedule.startTime : '00:00';
  const start = moment.tz(`${key} ${time}`, 'YYYY-MM-DD HH:mm', zone);
  if (start.isBefore(moment.tz(now, zone).add(Math.max(0, Number(schedule.minNotice) || 0), 'hours'))) return false;
  const months = /^(3|6|9|12)months$/.exec(schedule.maxNotice || '');
  return !months || day.isBefore(moment.tz(now, zone).add(Number(months[1]), 'months').endOf('day'));
}

export function firstExperienceDate(payload, now = new Date()) {
  const schedule = experienceSchedule(payload);
  if (!schedule) return null;
  if (schedule.calendar === 'specificDates') {
    return scheduleDates(schedule.dates).sort().find(day => isExperienceDateScheduled(day, payload, now)) || null;
  }
  const day = moment.tz(now, zone).startOf('day');
  for (let i = 0; i < 370; i += 1) {
    const key = day.format('YYYY-MM-DD');
    if (isExperienceDateScheduled(key, payload, now)) return key;
    day.add(1, 'day');
  }
  return null;
}
